/*import { AutofocusDirective } from './autofocus.directive';

describe('AutofocusDirective', () => {
  it('should create an instance', () => {
    const directive = new AutofocusDirective();
    expect(directive).toBeTruthy();
  });
});
*/

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
